import React, { useEffect, useRef } from "react";

// Renders Google's official "Sign in with Google" button (Google Identity Services).
// On success, calls onCredential(idToken, role) with the Google ID token — no redirects,
// so the sign-in popup can never land on a 404. The Client ID comes from env only.
const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export default function GoogleSignInButton({ role = "candidate", onCredential, text = "continue_with" }) {
  const divRef = useRef(null);
  const cbRef = useRef(onCredential);
  cbRef.current = onCredential;

  useEffect(() => {
    if (!CLIENT_ID) return undefined;
    let cancelled = false;

    const tryInit = () => {
      if (cancelled) return;
      const gid = window.google?.accounts?.id;
      if (!gid || !divRef.current) {
        setTimeout(tryInit, 150); // GIS script still loading
        return;
      }
      gid.initialize({
        client_id: CLIENT_ID,
        callback: (resp) => {
          if (resp?.credential) cbRef.current?.(resp.credential, role);
        },
      });
      divRef.current.innerHTML = "";
      gid.renderButton(divRef.current, {
        theme: "outline",
        size: "large",
        text,                    // "continue_with" | "signin_with"
        shape: "rectangular",
        width: 320,
        logo_alignment: "center",
      });
    };

    tryInit();
    return () => { cancelled = true; };
  }, [role, text]);

  if (!CLIENT_ID) {
    return (
      <div className="w-full rounded-xl border border-dashed border-border bg-secondary/40 px-4 py-3 text-center text-xs text-muted-foreground">
        Google sign-in isn’t configured yet.
      </div>
    );
  }

  return <div ref={divRef} className="flex justify-center" />;
}
